var map = {
	"./en.json": [
		1652,
		"src_assets_i18n-iso-countries_langs_en_json"
	],
	"./fr.json": [
		9803,
		"src_assets_i18n-iso-countries_langs_fr_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5835;
module.exports = webpackAsyncContext;